// useTriggerRecompute — useMutation for POST /api/admin/recompute-rankings
// (RANK-04 trigger #3). On 202 Accepted, invalidates ['recompute-status']
// so useRecomputeStatus immediately picks up the running flag. 409 throws
// ApiError with body { error, started_at } for the UI to show "Already
// running since X".

import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { triggerRecompute } from '@/lib/api';
import type { AdminRecomputeAcceptedResponse } from '@/types/db';

export function useTriggerRecompute(): UseMutationResult<
  AdminRecomputeAcceptedResponse,
  Error,
  void
> {
  const qc = useQueryClient();
  return useMutation<AdminRecomputeAcceptedResponse, Error, void>({
    mutationFn: () => triggerRecompute(),
    retry: false,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['recompute-status'] });
    },
  });
}
